import { render, staticRenderFns } from "./AddParentModal.vue?vue&type=template&id=65c754cb&scoped=true&"
import script from "./AddParentModal.vue?vue&type=script&lang=js&"
export * from "./AddParentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c754cb",
  null
  
)

export default component.exports